import { render, staticRenderFns } from "./LiveControls.vue?vue&type=template&id=5024561a&scoped=true&"
import script from "./LiveControls.vue?vue&type=script&lang=js&"
export * from "./LiveControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024561a",
  null
  
)

export default component.exports